module.exports = __webpack_public_path__ + "static/media/leaf_eater.7997f9e4.png";